import { defineAsyncComponent } from 'vue'
import { tabOutlineHistory } from 'quasar-extras-svg-icons/tabler-icons-v3'

import type { DrawerFeatureTwin, FeatureConfig } from 'src/models'
import { hasInvalidDigitalTwins } from 'src/utils/type-checks'

export interface HistoryFeatureTwin extends DrawerFeatureTwin {
  limit?: number
}

const featureConfig: FeatureConfig = {
  drawer: {
    drawerComponent: defineAsyncComponent(() => import('./HistoryFeatureDrawerMain.vue')),
    icon: tabOutlineHistory,
    label: 'History',
    hide: hasInvalidDigitalTwins
  }
}

export default featureConfig
